export default __webpack_public_path__ + "static/media/image 10.ea85bb3a.svg";